import angular from 'angular';
import indexRun from './index.run';
import uiRouter from '@uirouter/angularjs';
import Components from './components/components';
import Pages from './pages/pages';
import Services from './services/services';
import AppComponent from './app.component';
import ngSanitize from 'angular-sanitize';
import SessionProvider from './session.provider';
import AppController from './app.controller';
import apiConfig from './services/apiconfig';

angular.module('app', [
    uiRouter,
    Components,
    Pages,
    Services,
    ngSanitize
  ])
  .config($locationProvider => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
  })
  .component('app', AppComponent)
  .provider('SessionProvider', SessionProvider)
  .config($httpProvider => {
    "ngInject";
    $httpProvider.interceptors.push('SessionProvider')
  })
  .constant('APIConfig', apiConfig)
  .run(indexRun)
;



// WEBPACK FOOTER //
// ./client/app/app.js